import { render, staticRenderFns } from "./GTranslate.vue?vue&type=template&id=f0084082"
import script from "./GTranslate.vue?vue&type=script&lang=js"
export * from "./GTranslate.vue?vue&type=script&lang=js"
import style0 from "./GTranslate.vue?vue&type=style&index=0&id=f0084082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports